class AccountApi {
    constructor(api, opts) {
        this.api = api;
        this.options = {
            withCredentials: true,
            ...opts,
        };
    }

    update(data) {
        const { withCredentials } = this.options;
        return this.api.requestPost(this.api.route('account.update'), data, {
            withSession: !withCredentials,
            withCredentials,
        });
    }

    verifyEmail(data) {
        const { withCredentials } = this.options;
        return this.api.requestPost(this.api.route('verification.send'), data, {
            withSession: !withCredentials,
            withCredentials,
        });
    }

    films(query = {}) {
        const finalQuery = {
            ...query,
        };
        return this.api.requestGet(this.api.route('account.films.json'), finalQuery, {
            withSession: true,
        });
    }

    delete(data) {
        const { withCredentials } = this.options;
        return this.api.requestPost(this.api.route('account.destroy'), data, {
            withSession: !withCredentials,
            withCredentials,
        });
    }

    check(data) {
        const { withCredentials } = this.options;
        return this.api.requestPost(this.api.route('account.check'), data, {
            withSession: !withCredentials,
            withCredentials,
        });
    }
}

export default AccountApi;
